//
// Below mapper get rids of inline styling – if it matches a certain value – and replaces it with
// an abbreviated className. This way, we try to keep the DOM as compact as possible. For example,
// '{justifyContent: "flex-start"}' is replaced with '.jcfs'
// See the corresponding classNames in trim_named_styles.less
//
const STYLE_TO_CLASSNAME = [
	{styleName: 'width', className: 'fw', ifValue: '100%'},
	{styleName: 'maxWidth', className: 'mw', ifValue: '100%'},
	{styleName: 'height', className: 'fh', ifValue: '100%'},
	{styleName: 'maxHeight', className: 'mh', ifValue: '100%'},
	{styleName: 'flexDirection', ifValue: 'row'},
	{styleName: 'flexDirection', className: 'col', ifValue: 'column'},
	{styleName: 'position', className: 'rel', ifValue: 'relative'},
	{styleName: 'alignItems', ifValue: 'start'},
	{styleName: 'alignItems', ifValue: 'flex-start'},
	{styleName: 'alignItems', className: 'alc', ifValue: 'center'},
	{styleName: 'alignItems', className: 'ale', ifValue: 'end'},
	{styleName: 'alignItems', className: 'alu', ifValue: 'unset'},
	{styleName: 'justifyContent', className: 'jcfs', ifValue: 'flex-start'},
	{styleName: 'justifyContent', className: 'jcfe', ifValue: 'flex-end'},
	{styleName: 'justifyContent', className: 'jcc', ifValue: 'center'},
	{styleName: 'justifyContent', className: 'jcsb', ifValue: 'space-between'},
	{styleName: 'flexGrow', className: 'fg', ifValue: 1},
	{styleName: 'flexShrink', ifValue: 0},
	{styleName: 'flexShrink', className: 'fsu', ifValue: 'unset'},
	{styleName: 'display', className: 'db', ifValue: 'block'},
]

// Helper to delete inline styles if a certain style has a certain value.
export const trimNamedStyles = styles => {
	const deleteStyle = (style, value) => {
		const present = styles[style] === value
		if (present) styles = _.omitBy(styles, (v, k) => k === style && v === value)
	}

	// Convert verbose styles to abbreviated classNames.
	const classNames = []

	STYLE_TO_CLASSNAME.forEach(({styleName, className, ifValue}) => {
		const rename = styles[styleName] == ifValue
		if (!rename) return
		classNames.push(className)
		deleteStyle(styleName, ifValue)
	})

	return {styles, classNames}
}
